// Generated by ts-to-zod
import { z } from 'zod';
import {
  integrationCredentialSecretSchema,
} from '../models/integrationCredential.schema';

export const createIntegrationCredentialPayloadSchema = z.object({
  name: z.string(),
  type: z.string(),
  secret: integrationCredentialSecretSchema,
});
